
import { motion } from 'framer-motion';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Settings } from 'lucide-react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { slideInVariants } from '@/lib/animations';

const EmotionRecentEntries = () => {
  // Dados de exemplo para a tabela de registros recentes
  const recentEntries = [
    { data: '18/05/2025', ansiedade: 4, estresse: 7, calma: 3, felicidade: 5 },
    { data: '17/05/2025', ansiedade: 6, estresse: 5, calma: 4, felicidade: 6 },
    { data: '16/05/2025', ansiedade: 8, estresse: 8, calma: 2, felicidade: 3 },
    { data: '15/05/2025', ansiedade: 5, estresse: 6, calma: 5, felicidade: 4 },
    { data: '14/05/2025', ansiedade: 3, estresse: 4, calma: 7, felicidade: 7 },
  ];
  
  return (
    <motion.div
      variants={slideInVariants.up}
      initial="initial"
      animate="animate"
      transition={{ delay: 0.3 }}
    >
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <div>
            <CardTitle>Registros Recentes</CardTitle>
            <CardDescription>Seus últimos 5 registros emocionais</CardDescription>
          </div>
          <Button variant="ghost" size="icon">
            <Settings className="h-4 w-4" />
          </Button>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Data</TableHead>
                <TableHead>Ansiedade</TableHead>
                <TableHead>Estresse</TableHead>
                <TableHead>Calma</TableHead>
                <TableHead>Felicidade</TableHead>
                <TableHead></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {recentEntries.map((entry, index) => (
                <TableRow key={index}>
                  <TableCell>{entry.data}</TableCell>
                  <TableCell>
                    <div className="flex items-center">
                      <div className="h-2 w-full max-w-[60px] bg-gray-200 rounded-full mr-2 overflow-hidden">
                        <div className="h-full bg-red-400 rounded-full" style={{width: `${entry.ansiedade * 10}%`}}></div>
                      </div>
                      {entry.ansiedade}/10
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center">
                      <div className="h-2 w-full max-w-[60px] bg-gray-200 rounded-full mr-2 overflow-hidden">
                        <div className="h-full bg-orange-400 rounded-full" style={{width: `${entry.estresse * 10}%`}}></div>
                      </div>
                      {entry.estresse}/10
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center">
                      <div className="h-2 w-full max-w-[60px] bg-gray-200 rounded-full mr-2 overflow-hidden">
                        <div className="h-full bg-blue-400 rounded-full" style={{width: `${entry.calma * 10}%`}}></div>
                      </div>
                      {entry.calma}/10
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center">
                      <div className="h-2 w-full max-w-[60px] bg-gray-200 rounded-full mr-2 overflow-hidden">
                        <div className="h-full bg-green-400 rounded-full" style={{width: `${entry.felicidade * 10}%`}}></div>
                      </div>
                      {entry.felicidade}/10
                    </div>
                  </TableCell>
                  <TableCell>
                    <Button variant="ghost" size="sm">Detalhes</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default EmotionRecentEntries;
